import { render, staticRenderFns } from "./tabs-select.vue?vue&type=template&id=62807f84&scoped=true"
import script from "./tabs-select.vue?vue&type=script&lang=js"
export * from "./tabs-select.vue?vue&type=script&lang=js"
import style0 from "./tabs-select.vue?vue&type=style&index=0&id=62807f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62807f84",
  null
  
)

export default component.exports